function SingSaverMarkIcon({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Icons">
        <path
          id="Vector"
          d="M3.33521 12.0122C3.33521 12.0122 7.16197 15.8577 9.12842 20.727C9.12842 20.727 15.8768 7.19911 20.6649 3.27246C20.6649 3.27246 16.8194 4.64585 9.12842 14.2409C9.12842 14.2409 5.6887 12.0122 3.33521 12.0122Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default SingSaverMarkIcon;
